import './Header.css';

function Header() {
  return (
    <div>
      <div className="header">
        <h1>Piłka jest okrągła</h1>
      </div>
      <div className="topnav">
        <a href="#">Link</a>
        <a href="#">Link</a>
        <a href="#">Link</a>
        <a href="#" style={{float:"right"}}>Link</a>
      </div>
    </div>
  );
}

export default Header;
